<!--page starts-->
<section class="page-wrapper">
   <div class="shop-single-section margin-top-152 cf"> 
       <div class="container">
           <div class="shop-single-detail">
               <div class="shop-single-detail-left">
                   <div class="shop-single-shop-left">
                        <div class="shop-single-shop-image" *ngIf="productSingle?.image">
                            <a href="javascript:void(0);">
                               <img [src]="productSingle?.image">
                            </a>
                        </div>
                        <!-- <div class="shop-single-shop-image">
                            <a href="#">
                               <img src="assets/images/shop-img1.png">
                            </a>
                        </div> -->
                   </div>
                   <div class="shop-single-shop-right">
                        <div class="shop-single-shop-right-image" *ngIf="productSingle?.image">
                            <a href="javascript:void(0);">
                               <img [src]="productSingle?.image">
                            </a>
                        </div>
                   </div>
               </div>
               <div class="shop-single-detail-right">
                   <div class="shop-single-detail-right-detail">
                        <h3>{{productSingle?.title}} </h3>
                        <div class="shop-single-price" *ngIf="productSingle?.amount">
                           <p>{{productSingle?.amount | currency:'&#163;'}}</p>
                        </div>
                        <div class="shop-availability" *ngIf="productSingle?.availability">
                            <h4>Availability: {{productSingle?.availability}}</h4>
                        </div>  
                        <div class="shop-content" [innerHTML]="productSingle?.description">
                            
                            <!-- <p>Please note: Printing of names and numbers is not included and is not available as an add-on.</p> -->
                        </div>
                        <div class="shop-select-box">
                            <div class="shop-select-size" *ngIf="productSingle?.product_size?.length > 0"> 
                                <div class="custom-select">
                                    <select id="select_size" (change)="sizeaction()">
                                        <option>Select Size</option>
                                        <option value="{{size?.product_size_master_id}}" *ngFor="let size of productSingle?.product_size" class="size" id="{{size?.product_size_master_id}}">{{size?.size}}</option>
                                    </select>
                                  </div>
                            </div>
                            <div class="away-fans" *ngIf="productSingle?.availability === 'InStock'">
								<div  class="select-box">
                                    <div  class="product-quantity">
                                       <div  class="product-quantity-box">
                                          <input data-min="0" id="quantity" name="quantity" readonly="true" type="text" value="1">
                                          <input id="price" name="price" readonly="true" type="text">
                                          <div  class="quantity-selectors-container">
                                             <div  class="quantity-selectors">
                                                <button  class="increment-quantity" data-direction="1" aria-label="Add one" type="button" id="5">
                                                    <span>+</span>
                                                </button>
                                                <button class="decrement-quantity" aria-label="Subtract one" data-direction="-1" type="button" id="5">
                                                    <span>−</span>
                                                </button>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
							</div>
                        </div>
                        <div class="shop-btn">
                            <ul>
                                <li *ngIf="sizeoutstock"><button (click)="add_to_cart()">Add to Cart</button></li>
                                <li *ngIf="sizeinstock"><button disabled class="gray">Add to Cart</button></li>
                                <!-- <li><button>buy now</button></li> -->
                            </ul>
                        </div>
                   </div>
               </div>
           </div>
           <div class="similliar-products-section cf">
                <div class="titel-box">
                    <h2 class="titel-name">Similar Products</h2>
                </div>
                <div class="similliar-products-detail">
                    <div class="shop-lccc-club-main">
                        <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideshopConfig">
                            <div ngxSlickItem class="shop-lccc-club-box slide" *ngFor="let product of productList?.data">
                                <a href="#">
                                    <div class="shop-lccc-club-box-inner">
                                        <div class="shop-lccc-club-box-inner-img" *ngIf="product?.image">
                                            <img [src]="product?.image">
                                        </div>
                                    </div>
                                    <div class="shop-lccc-club-box-content">
                                        <h3>{{product?.title}} </h3>
                                        <p *ngIf="product?.amount">{{product?.amount | currency:'&#163;'}}</p>
                                    </div>
                                </a>
                            </div>
                          
                        </ngx-slick-carousel>
                    </div>
                </div>
           </div>
       </div>
   </div>
    
</section><!-- page ends-->
